import { defineStore } from "pinia";
import router from "@/router";
import { userService } from "@/services/user.service";
import {
  ListUserNetworkRequestSchema,
  ListUsersRequestSchema,
  UpdateUserRequest,
  UpdateUserRequestSchema,
  UserProfile,
} from "@/gen/api/v1/user_pb";
import { create } from "@bufbuild/protobuf";
import { FieldMaskSchema } from "@bufbuild/protobuf/wkt";

export const useUserStore = defineStore("user", {
  state: () => ({
    user: null as UserProfile | null,
    users: [] as UserProfile[],
    network: [] as UserProfile[],
  }),
  getters: {
    totalEarnings: (state): number => state.user?.totalEarnings || 0,
    affiliateEarnings: (state): number => state.user?.affiliateEarnings || 0,
  },
  actions: {
    async getProfile() {
      try {
        const response = await userService.getProfile();
        this.user = response;
        return this.user;
      } catch {
        localStorage.removeItem("accessToken");
        router.push("/auth/login");
        return null;
      }
    },

    async updateProfile(user: UpdateUserRequest) {
      const response = await userService.updateProfile(
        create(UpdateUserRequestSchema, {
          user: {
            email: user.user?.email,
            phone: user.user?.phone,
            avatar: user.user?.avatar,
            birthday: user.user?.birthday,
            fullName: user.user?.fullName,
          },
          updateMask: create(FieldMaskSchema, {
            paths: ["email", "phone", "avatar", "birthday", "fullName"],
          }),
        }),
      );
      this.user = response;
    },

    async listUsers() {
      const response = await userService.listUsers(
        create(ListUsersRequestSchema, {
          page: 1,
          pageSize: 10,
        }),
      );
      this.users = response.users;
    },

    async getUserSponsoredChain(userId: number) {
      const response = await userService.getUserSponsoredChain(
        create(ListUserNetworkRequestSchema, {
          userId: userId,
          page: 1,
          pageSize: 10,
        }),
      );
      this.network = response.users;
      return response.users;
    },
  },
});
